import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { state } from './state'

export const room = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
